import 'rc-slider/assets/index.css';
import "./rcSlider.scss";
import * as React from "react";
import Slider from "rc-slider";
import Amount from "../../../../model/common/Amount";
import {Option} from "ts-option";

interface ComponentProps {
	/**
	 * Width of slider container in pixels
	 */
	width: Option<number>;
	/**
	 * Slider title
	 */
	title: Option<string>;
	/**
	 * Additional css class
	 */
	className: Option<string>;
	/**
	 * Initial value (may be out of range)
	 */
	startValue: Option<number>;
	/**
	 * Slider minimum value
	 */
	min: number;
	/**
	 * Slider maximum value
	 */
	max: number;
	/**
	 * Slider step
	 */
	step: number;
	/**
	 * Callback after slider value has been changed
	 * @param value
	 */
	onChanged: (value: number) => void
}

interface State {
	/**
	 * Current value (can be out of range)
	 */
	value: number;
	/**
	 * Slider value (in slider range)
	 */
	sliderValue: number;
	/**
	 * Initial value (in slider range)
	 */
	sliderStartValue: number;
	/**
	 * Value to formatted display
	 */
	displayValue: Amount;
}

export default class HiberSlider extends React.Component<ComponentProps, State> {

	constructor(props: ComponentProps) {
		super(props);
		const startValueProper = props.startValue.isDefined ? Math.ceil(props.startValue.get / props.step) * props.step : null;
		const sliderStartValue = props.startValue.isDefined ? (startValueProper > props.min ? startValueProper : props.min) :
			props.min;
		this.state = {
			displayValue: props.startValue.isDefined ? new Amount(props.startValue.get * 100) : new Amount(props.min * 100),
			value: props.startValue.isDefined ? props.startValue.get : props.min,
			sliderStartValue: sliderStartValue,
			sliderValue: sliderStartValue
		}
	}

	onSliderChange = (value: number) => {
		this.setStateValues(value);
	};

	onAfterChange = (value: number) => {
		this.props.onChanged(value);
	};

	reset = () => {
		if (this.props.startValue.isDefined) {
			this.setState({
				value: this.props.startValue.get,
				sliderValue: this.state.sliderStartValue,
				displayValue: new Amount(this.props.startValue.get * 100)
			});
			this.props.onChanged(this.props.startValue.get);
		}
	};

	increase = () => {
		const newVal = this.state.value < this.props.min ? this.props.min : (this.state.sliderValue + this.props.step);
		if (newVal <= this.props.max) {
			this.setStateValues(newVal);
			this.props.onChanged(newVal);
		}
	};

	decrease = () => {
		const newVal = this.state.value > this.props.max ? this.props.max : (this.state.sliderValue - this.props.step);
		if (newVal >= this.props.min) {
			this.setStateValues(newVal);
			this.props.onChanged(newVal);
		}
	};

	private setStateValues = (value: number) => {
		this.setState({value: value, sliderValue: value, displayValue: new Amount(value * 100)});
	};

	render() {
		const style = {width: this.props.width.isDefined ? this.props.width.get : 300};
		return (
			<div className={"h-slider-wrapper " + (this.props.className.getOrElse(''))} style={style}>
				<div className={"h-slider-header"}>
					<div>
						<b>{this.props.title.getOrElse('')}</b>
					</div>
					<div className={"show-value-wrapper"}>
						<span onClick={this.decrease} className={"arrow arrow-left"}><i
							className={"fa fa-lg fa-arrow-left"}/></span>
						<div className={"show-value"}>
							<b>{this.state.displayValue.format()}</b> <span onClick={this.reset} className={"t-link"}>reset</span>
						</div>
						{this.props.startValue.isDefined && <span onClick={this.increase} className={"arrow arrow-right"}><span><i
							className={"fa fa-lg fa-arrow-right"}/></span></span>}
					</div>
					<div></div>
				</div>
				<div className={"slider-box"}>
					<Slider value={this.state.sliderValue} min={this.props.min} max={this.props.max} step={this.props.step}
							onChange={this.onSliderChange} onAfterChange={this.onAfterChange}
					/>
				</div>
			</div>
		)
	}

}
